import { pageLayoutStyles } from '../../components/ui/page-layout';
import investOttawaLogo from '../../client/static/invest-ottawa-logo.svg';
import { HubLocationLinks } from './hubLandingLinks';

export default function DefaultReceptionPage() {
  return (
    <div className={pageLayoutStyles.layout.container}>
      <div className="text-center mb-16 mt-8">
        <div className="flex justify-center mb-8">
          <img
            src={investOttawaLogo}
            alt="Invest Ottawa"
            className="h-24 sm:h-32 w-auto object-contain"
          />
        </div>
        <p className="text-xl text-muted-foreground max-w-3xl mx-auto leading-relaxed">
          Lead Economic Development Agency. Fuelling every step of your business journey by helping you leverage the best programs, people, and places to make your mark in Canada's Capital.
        </p>
      </div>

      <HubLocationLinks className="pb-16" />
    </div>
  );
}
